import { InputBase } from "@mantine/core";
import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useUpdateQuoteRequestReference } from "#modules/quoteRequests/view/useUpdateQuoteRequestReference";
import { selectInputOnFocus } from "#shared/helpers/selectInputOnFocus";
import { quoteRequestAtom } from "#shared/view/components/AppShell/Atoms";
import { EditLink } from "#shared/view/components/AppShell/EditLink";

export const QuoteRequestReference = () => {
  const { t } = useTranslation();
  const quoteRequest = useAtomValue(quoteRequestAtom);

  const [currentReference, setCurrentReference] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (!isEditing) {
      setCurrentReference(quoteRequest?.reference || "");
    }
  }, [quoteRequest?.reference, isEditing]);

  const { updateQuoteRequestReference } = useUpdateQuoteRequestReference();

  const saveReference = () => {
    if (currentReference === "") {
      cancelPendingEditing();
    } else {
      updateQuoteRequestReference({
        id: quoteRequest?.id || "",
        reference: currentReference,
      });

      setIsEditing(false);
    }
  };

  const cancelPendingEditing = () => {
    setCurrentReference(quoteRequest?.reference || "");
    setIsEditing(false);
  };

  return (
    <>
      {!isEditing && (
        <EditLink
          defaultText={t("quoteRequestLine.requestReferencePlaceholder")}
          dataText={currentReference}
          setIsEditing={setIsEditing}
        />
      )}

      {isEditing && (
        <InputBase
          autoFocus
          size="xs"
          px="xs"
          placeholder={t("quoteRequestLine.requestReferencePlaceholder")}
          value={currentReference}
          onFocus={selectInputOnFocus}
          onBlur={saveReference}
          onChange={(e) => {
            setCurrentReference(e.target.value);
          }}
          onKeyUp={(e) => {
            if (e.key === "Enter") {
              saveReference();
            }
            if (e.key === "Escape") {
              cancelPendingEditing();
            }
          }}
        />
      )}
    </>
  );
};
